export const MainRoutes = [{
  name: 'main',
  path: '/',
  component: () => import(/* webpackChunkName: "MainModule" */ './Module')
}];
